<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<div *ngIf="id < shownList  && tab?.mode!=='edit'">
    <li>{{note.timestamp|locoBlankString}}</li>
    <li>{{note.userIdentifier|locoBlankString}}</li>
    <li>{{note.noteText|locoBlankString}}</li>
</div>
<div *ngIf="id < shownList && tab?.mode==='edit'" [formGroup]="locoNotesForm">
    <li>{{note.timestamp|locoBlankString}}</li>
    <li>{{note.userIdentifier|locoBlankString}}</li>
    <li>
        <div class='{{deleteNoteClass}} block-view '>
            <input type="text" *ngIf="buttonLabel==='Delete'" class="{{locoNotesForm.valid?' p-inputfield ':'p-inputfield-error p-inputfield'}}" required formControlName="noteText" maxlength="62" (ngModelChange)="updateSearchText($event)">
            <input type="text" *ngIf="buttonLabel==='Cancel'" disabled="disabled" class="p-inputfield" formControlName="noteText" maxlength="62">
        </div>
        <a href="javascript:;;" class="delete-note" (click)="deleteCancelNoteData()">{{buttonLabel}}</a></li>
</div>